<template>
  <v-menu
    open-on-hover
    bottom
    origin="center center"
    transition="slide-y-transition"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :loading="maestro===null ?  false: maestro.length === 0"
        :disabled="maestro===null ? true :maestro.length === 0"
        color="primary"
        light
        v-bind="attrs"
        v-on="on"
        plain
        text
        to="/#Productos"
        :class="[
          {
            'mt-3': !Cliente.showOpc && $vuetify.breakpoint.lgAndDown,
          },
        ]"
      >
        PRODUCTOS
      </v-btn>
    </template>
    <v-list color="primary" dark dense>
      <v-list-item
        v-for="(item, index) in categorias"
        :key="index"
        @click="
          CLR_DATOS_SUBCAT();
          idSubCat(item.CodigoDiv, item.CodigoDep, item.Categoria);
        "
        :to="`/subcategoria/${item.CodigoDiv}/${item.CodigoDep}/${item.Categoria}`"
      >
        <v-list-item-title>{{ item.Nombre }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions(["consolidadoSCategoria"]),
    ...mapMutations([
      "CLR_DATOS_SUBCAT",
      "GET_BUSCARCAT",
      "CLR_ERROR_AXIOS",
      "CLR_BUSCAREPUESTO",
      "set_changeSubcatF",
      "CLR_DATOS_ART",
      "set_AdPromoF",
      "set_varCategorias",
    ]),
    idSubCat(Div, Dep, Cat) {
      this.GET_BUSCARCAT(Cat);
      window.scrollTo(0, 0);
      this.CLR_ERROR_AXIOS();
      // this.CLR_DATOS_SUBCATB();
      this.CLR_BUSCAREPUESTO();
      this.set_changeSubcatF();
      this.CLR_DATOS_ART();
      // this.CLR_PROMO();
      this.set_AdPromoF();
      this.set_varCategorias([Div, Dep, Cat]);
     // if (!this.$route.params.codart) this.consolidadoSCategoria();
      if (this.$route.params.cat)
        //  console.log("f5");
        this.dialog = false;
    },
  },
  computed: {
    ...mapState(["maestro", "Cliente"]),
    categorias() {
      let cat = [];
      const { ttCategoria } = this.maestro || {};
      if (ttCategoria !== undefined) cat = ttCategoria;
      else cat = null
      return cat;
    },
  },
};
</script>

<style></style>
